"use client";

import { useState, type ReactNode } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import type { Locale } from "@/i18n-config";
import { ClientLocaleProvider } from "@/components/providers/client/LocaleProvider";
import { ClientAuthProvider } from "@/components/providers/client/AuthProvider";
import { ClientAccountProvider } from "@/components/providers/client/AccountProvider";
import { ObfuscationProvider } from "@/components/obfuscation/ObfuscationProvider";
import {
  AdminMenu,
  type AdminMenuDictionary,
} from "@/components/admin/AdminMenu";

export function SiteClientProviders({
  locale,
  dictionary,
  children,
}: {
  locale: Locale;
  dictionary: AdminMenuDictionary;
  children: ReactNode;
}) {
  const [queryClient] = useState(() => new QueryClient());
  return (
    <QueryClientProvider client={queryClient}>
      <ClientLocaleProvider locale={locale}>
        <ClientAuthProvider>
          <ObfuscationProvider>
            <ClientAccountProvider>{children}</ClientAccountProvider>
            <AdminMenu dictionary={dictionary} />
          </ObfuscationProvider>
        </ClientAuthProvider>
      </ClientLocaleProvider>
    </QueryClientProvider>
  );
}
